/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route_details__expense_note_section__edit__title = /** @type {(inputs: {}) => string} */ () => {
	return `Reisekostenabrechnung ändern`
};

const en_route_details__expense_note_section__edit__title = /** @type {(inputs: {}) => string} */ () => {
	return `Edit expense note`
};

const es_route_details__expense_note_section__edit__title = /** @type {(inputs: {}) => string} */ () => {
	return `Modificar la nota de gastos`
};

const fr_route_details__expense_note_section__edit__title = /** @type {(inputs: {}) => string} */ () => {
	return `Modifier la note de frais`
};

const it_route_details__expense_note_section__edit__title = /** @type {(inputs: {}) => string} */ () => {
	return `Modifica della nota spese`
};

const nl_route_details__expense_note_section__edit__title = /** @type {(inputs: {}) => string} */ () => {
	return `Onkostennota wijzigen`
};

const pt_route_details__expense_note_section__edit__title = /** @type {(inputs: {}) => string} */ () => {
	return `Modificar a nota de despesas`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route_details__expense_note_section__edit__title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route_details__expense_note_section__edit__title", locale)
	if (locale === "de") return de_route_details__expense_note_section__edit__title(inputs)
	if (locale === "en") return en_route_details__expense_note_section__edit__title(inputs)
	if (locale === "es") return es_route_details__expense_note_section__edit__title(inputs)
	if (locale === "fr") return fr_route_details__expense_note_section__edit__title(inputs)
	if (locale === "it") return it_route_details__expense_note_section__edit__title(inputs)
	if (locale === "nl") return nl_route_details__expense_note_section__edit__title(inputs)
	return pt_route_details__expense_note_section__edit__title(inputs)
};